import type { IToastProps } from '@ping/uikit';

export const TOAST_OPTIONS: IToastProps = {
  theme: 'colored',
  position: 'top-right',
  hideProgressBar: false,
  rtl: false,
  autoClose: 4000,
};
